import { Component, OnInit, Output, Input, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Table } from 'primeng/table';
import { InternalinvoiceService } from './Service/internalinvoice.service';
import { Agency, Orders, OrderInvoice } from './Model/InternalModel';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-internalinvoice',
  templateUrl: './internalinvoice.component.html',
  styleUrls: ['./internalinvoice.component.css'],
  providers: [InternalinvoiceService]
})
export class InternalinvoiceComponent implements OnInit {

  @ViewChild('dt') private _invoiceTable: Table;
  @ViewChild('dtr') private _ordersTable: Table;
  ShowInvoice: boolean;
  ShowOrder: boolean;
  agency: Agency[];
  agencyFilter: any[];
  loadingInvoice: boolean;
  loadingOrder: boolean;
  Invoice: any = [];
  newAgency: any = [];
  newOrderAgency: any = [];
  Orders: any = [];
  // filtering
  enableInvoiceFilter: boolean;
  isInvoice_InvoiceFilterEndDateDisabled: boolean;
  invoice_InvoiceFilterStartDate: any;
  invoice_InvoiceFilterEndDate: any;

  isInvoice_DueFilterEndDateDisabled: boolean;
  invoice_DueFilterStartDate: any;
  invoice_DueFilterEndDate: any;

  enableOrdersFilter: boolean;
  isOrder_ordFilterEndDateDisabled: boolean;
  orders_ordFilterStartDate: any;
  orders_ordFilterEndDate: any;

  OrderRelatedInvoiceId: string;
  OrderInvoice: any = [];
  loadingOrderInvoicepopup: boolean;
  loading: boolean;
  IsinvoicedFlag: boolean;

  display: boolean = false;
  urlSafe: SafeResourceUrl; 

  showIframe: boolean = false;
  fileNotFound: boolean = false;
  fileLoading: boolean = false;

  constructor(private internalinvoiceService: InternalinvoiceService, public datepipe: DatePipe, private http: HttpClient, public changeDetectorRef: ChangeDetectorRef, public sanitizer: DomSanitizer) {

      this.enableOrdersFilter = false;
      this.isOrder_ordFilterEndDateDisabled = true;
      this.display = false;
      this.isInvoice_DueFilterEndDateDisabled = true;
      this.isInvoice_InvoiceFilterEndDateDisabled = true;
      this.enableInvoiceFilter = false;
    }

  ngOnInit() {
    this.internalinvoiceService.getAgencyList()
      .subscribe(resAgencyData => this.agency = resAgencyData);
    this.ShowInvoice = true;
    this.newAgency = JSON.parse(sessionStorage.getItem('selectedAgency'));

    if (this.newAgency != null) {

      this.GetInvoiceGrid(this.newAgency.agencyID);
      this.GetOrderGrid(this.newAgency.agencyID);
    }
    // this.newOrderAgency = JSON.parse(sessionStorage.getItem('selectedOrderAgency'));
    // if (this.newOrderAgency != null) {
    //   this.GetOrderGrid(this.newOrderAgency.agencyID);
    // }
    this._invoiceTable.filterConstraints['inv_invDate'] = (value, filter): boolean => {

      let startDate = new Date(this.datepipe.transform(filter[0], 'yyyy-MM-dd'));
      let endDate = new Date(this.datepipe.transform(filter[1], 'yyyy-MM-dd'));

      let rowDate = new Date(value);

      return (rowDate >= startDate && rowDate <= endDate);
    };
    this._invoiceTable.filterConstraints['inv_dueDate'] = (value, filter): boolean => {

      let startDate = new Date(this.datepipe.transform(filter[0], 'yyyy-MM-dd'));
      let endDate = new Date(this.datepipe.transform(filter[1], 'yyyy-MM-dd'));

      let rowDate = new Date(value);

      return (rowDate >= startDate && rowDate <= endDate);

    };

    this._ordersTable.filterConstraints['ord_ordDate'] = (value, filter): boolean => {

      let startDate = new Date(this.datepipe.transform(filter[0], 'yyyy-MM-dd'));
      let endDate = new Date(this.datepipe.transform(filter[1], 'yyyy-MM-dd'));

      let rowDate = new Date(value);

      return (rowDate >= startDate && rowDate <= endDate);
    };
  }

  // PDF Popup
  viewFile(id: string) {
    //debugger;
    if(id != null)
      {
        this.showIframe = false;
        this.fileNotFound = false;
        this.fileLoading = false;

        this.display = true;

        this.fileLoading = true;

        this.internalinvoiceService.getDownloadUrl(id).subscribe(response => {
          //debugger;
          if(response)
            {
              this.fileLoading = false;
              this.showIframe = true;
              this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(response);
            }
          else
            {
              this.fileLoading = false;
              this.fileNotFound = true;
            }  

        });
        
    
      }
    
  }

  // Method to show Invoice tab
  showInvoice() {
    this.ShowInvoice = true;
    this.ShowOrder = false;
  }
  // Method to show Order tab
  OrdersTab() {
    this.ShowInvoice = false;
    this.ShowOrder = true;
  }
  // Method to filter data for Autocomplete starts
  agencyAutocompleteFilter(event) {

    let query = event.query;
    this.agencyFilter = this.filterAgency(query, this.agency);
  }
  filterAgency(query, resAgencyData): any[] {

    let filtered: any[] = [];
    query = query.toLowerCase();

    for (let i = 0; i < resAgencyData.length; i++) {
      let agency = resAgencyData[i];

      if (agency.agencyName.toLowerCase().indexOf(query) === 0 || agency.agencyID.toString().toLowerCase().indexOf(query) === 0) {
        filtered.push(agency);
      }
    }
    return filtered;
  }
  // Method to filter data for Autocomplete ends
  // Method to filter data for Invoice based on the agency selected.
  GetInvoiceGrid(agency) {
    this.loadingInvoice = true;
    this.internalinvoiceService.GetInvoiceGrid(agency).subscribe(
      p => { this.Invoice = p, this.loadingInvoice = false; }
    );

    console.log(this.Invoice);
  }
  // Method to filter data for Order based on the agency selected.
  GetOrderGrid(agency) {
    this.loadingOrder = true;
    this.internalinvoiceService.GetOrderGrid(agency).subscribe(
      p => {
        this.Orders = p, this.loadingOrder = false;
      }
    );
    console.log(this.Orders);
  }
  // Method to filter data for Invoice based on the agency selected.
  InvoiceDetail() {
    sessionStorage.setItem('selectedAgency', JSON.stringify(this.newAgency));
    if (this.newAgency != null) {
      this.GetInvoiceGrid(this.newAgency.agencyID);
      this.GetOrderGrid(this.newAgency.agencyID);
    } else {
      this.GetInvoiceGrid(0);
      this.GetOrderGrid(0);
    }

  }
  // Method to filter data for Order based on the agency selected.
  OderDetail(event) {

    //sessionStorage.setItem('selectedOrderAgency', JSON.stringify(this.newAgency));
    sessionStorage.setItem('selectedAgency', JSON.stringify(this.newAgency));
    if (this.newAgency != null) {
      this.GetOrderGrid(this.newAgency.agencyID);
      this.GetInvoiceGrid(this.newAgency.agencyID);
    } else {
      this.GetOrderGrid(0);
      this.GetInvoiceGrid(0);
    }
  }
  // Filter
  invoiceFilterToggle(event) {
    this.enableInvoiceFilter === false ? this.enableInvoiceFilter = true : this.enableInvoiceFilter = false;
    if (!this.enableInvoiceFilter) {
      this._invoiceTable.reset();
      this.isInvoice_InvoiceFilterEndDateDisabled = true;
      this.isInvoice_DueFilterEndDateDisabled = true;
    }
  }
  ordersFilterToggle(event) {
    this.enableOrdersFilter === false ? this.enableOrdersFilter = true : this.enableOrdersFilter = false;
    if (!this.enableOrdersFilter) {
      this._ordersTable.reset();
      this.isOrder_ordFilterEndDateDisabled = true;
    }

  }

  clearInvoiceValue() {
    this.newAgency = null;

  }
  clearOrderValue() {
    this.newAgency = null;

  }



  // order popup functions
  GetOrderInvoiceClick(orderInvoiceid, invoice_flag) {
  
    this.OrderInvoice = '';
    this.loadingOrderInvoicepopup = true;
    this.newAgency = JSON.parse(sessionStorage.getItem('selectedAgency'));
    this.OrderRelatedInvoiceId = orderInvoiceid;
    if (invoice_flag === 'YES') {
      this.IsinvoicedFlag = true;
      this.internalinvoiceService.GetOrderInvoiceGrid(this.OrderRelatedInvoiceId, this.newAgency.agencyID).subscribe(
        p => { this.OrderInvoice = p, this.loadingOrderInvoicepopup = false; }
      );
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
      console.log(this.OrderInvoice);
    } else {
      this.IsinvoicedFlag = false;

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/internalinvoice/internalinvoice.component.ts